import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './Register.css';

const API_URL = process.env.REACT_APP_API_URL;

const Register = () => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Récupère l'e-mail depuis les paramètres de l'URL à l'arrivée sur la page
    const emailFromUrl = searchParams.get('email');
    if (emailFromUrl) {
      setEmail(emailFromUrl);
    } else {
      alert("Lien d'inscription invalide ou expiré.");
    }
  }, [searchParams]);

  const handleRegister = async (e) => {
    e.preventDefault();
    if (!email) {
      alert("Impossible de s'inscrire sans e-mail. Veuillez utiliser le lien d'invitation.");
      return;
    }
    if (password !== confirmPassword) {
      alert("Les mots de passe ne correspondent pas !");
      return;
    }
    if (password.length < 8) {
      alert("Le mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (name.trim() === '') {
        alert("Veuillez entrer votre nom complet.");
        return;
    }

    try {
        const response = await fetch(`${API_URL}/api/register`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password, name })
        });

        if (response.ok) {
            alert("Inscription réussie ! Vous allez être redirigé vers la page de connexion.");
            navigate('/login');
        } else {
            const errorData = await response.json();
            alert(`Erreur lors de l'inscription: ${errorData.error}`);
        }
    } catch (error) {
        alert("Une erreur réseau est survenue. Veuillez réessayer.");
    }
  };

  return (
    <div className="register-container">
      <form onSubmit={handleRegister} className="register-form">
        <h2>Finaliser l'inscription</h2>
        <p>Bienvenue, <strong>{email}</strong>. Veuillez compléter vos informations.</p>
        <input
          type="text"
          placeholder="Nom et prénom"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit">Créer le compte</button>
      </form>
    </div>
  );
};

export default Register;
